import { render, staticRenderFns } from "./SubArticleListApp.vue?vue&type=template&id=ecd280a0&"
import script from "./SubArticleListApp.vue?vue&type=script&lang=js&"
export * from "./SubArticleListApp.vue?vue&type=script&lang=js&"
import style0 from "./SubArticleListApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports